import { render, staticRenderFns } from "./CardPerfil.vue?vue&type=template&id=3802346e&"
import script from "./CardPerfil.vue?vue&type=script&lang=ts&"
export * from "./CardPerfil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports